// Утилита для генерации sitemap на основе реальных данных
import { BLOG_POSTS } from '@/mock';

export const generateStaticSitemap = () => {
    const baseUrl = 'https://cope.by';
    
    // Статические страницы
    const staticPages = [
        { url: '/', priority: 1.0, changefreq: 'daily', lastmod: '2024-01-01' },
        { url: '/articles', priority: 0.8, changefreq: 'weekly', lastmod: '2024-01-01' },
        { url: '/tests', priority: 0.8, changefreq: 'weekly', lastmod: '2024-01-01' },
    ];

    // Статьи из BLOG_POSTS
    const articles = BLOG_POSTS.map(post => ({
        url: `/article/${post.id}`,
        priority: 0.9,
        changefreq: 'weekly',
        lastmod: post.date.includes('2024-10-15') ? '2024-10-15' :
                post.date.includes('2024-10-10') ? '2024-10-10' :
                post.date.includes('2024-10-05') ? '2024-10-05' : '2024-01-01'
    }));

    // Генерируем XML
    const urls = [
        ...staticPages.map(page => formatUrl(page.url, page.priority, page.changefreq, page.lastmod)),
        ...articles.map(article => formatUrl(article.url, article.priority, article.changefreq, article.lastmod))
    ];

    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.join('\n')}
</urlset>`;
};

const formatUrl = (path, priority, changefreq, lastmod) => {
    const url = `https://cope.by${path}`;
    
    return `  <url>
    <loc>${url}</loc>
    <lastmod>${lastmod}</lastmod>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;
};

// Функция для обновления sitemap.xml файла
export const updateSitemapFile = () => {
    const sitemap = generateStaticSitemap();
    console.log('Generated sitemap:');
    console.log(sitemap);
    return sitemap;
};
